import { fetch } from '../../utils';
import Backend from '../../backend';

export const getFigure = () => {
  return fetch(Backend.methodUrl('figure'), {
    method: 'GET'
  })
    .then(res => {
      return res.json();
    })
    .then(payload => {
      return payload;
    })
    .catch(error => {
      throw error;
    });
};
